@if (visiblePopups().length > 0) {
  <!-- 오버레이 배경 -->
  <div class="fixed inset-0 z-9999 bg-black/60"></div>

  <!-- PC: 가로 나열 레이아웃 (md 이상) -->
  <div class="hidden md:flex fixed inset-0 z-9999 items-center justify-center p-4 pointer-events-none">
    <div class="flex items-center justify-center gap-4 max-w-full overflow-x-auto pointer-events-auto">
      @for (popup of visiblePopups(); track popup.id) {
        <div
          class="popup-enter relative bg-white rounded-lg overflow-hidden shadow-2xl shrink-0 w-[480px] max-h-[90vh] flex flex-col items-center">
          <!-- 닫기 버튼 -->
          <button
            (click)="closePopup(popup.id)"
            class="absolute cursor-pointer top-3 right-3 z-10 size-8 flex items-center justify-center bg-white/30 text-gray-700 rounded-full hover:bg-white transition-colors">
            <span class="icon-[material-symbols--close] text-xl"></span>
          </button>

          <!-- 이미지 (3:4 비율) -->
          @if (popup.link) {
            <a
              [href]="popup.link"
              target="_blank"
              rel="noopener noreferrer"
              class="block aspect-3/4 max-h-[calc(90vh-4rem)] w-full overflow-hidden">
              <img [src]="popup.image" [alt]="popup.title" class="block w-full h-full object-cover" />
            </a>
          } @else {
            <div class="aspect-3/4 max-h-[calc(90vh-4rem)] w-full overflow-hidden">
              <img [src]="popup.image" [alt]="popup.title" class="block w-full h-full object-cover" />
            </div>
          }

          <!-- 하단 액션 영역 -->
          <div class="w-full flex items-center justify-between px-4 py-3 border-t border-gray-200 bg-gray-50 shrink-0">
            <button
              (click)="hideForToday(popup.id)"
              class="cursor-pointer text-sm text-gray-500 hover:text-primary transition-colors">
              오늘 하루 보지 않기
            </button>
            <button
              (click)="closePopup(popup.id)"
              class="cursor-pointer px-4 py-1.5 text-sm font-medium text-white bg-primary hover:brightness-90 rounded-md transition-colors">
              닫기
            </button>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- 모바일: 중앙 팝업 (md 미만) - 카드 고정, 이미지만 스와이프 -->
  <div class="popup-enter md:hidden fixed inset-0 z-9999 flex items-center justify-center p-4 pointer-events-none">
    <div class="w-full max-w-[340px] pointer-events-auto">
      <div class="relative bg-white rounded-xl overflow-hidden shadow-2xl max-h-[85vh] flex flex-col">
        <!-- 닫기 버튼 -->
        <button
          (click)="closeAllPopups()"
          class="absolute cursor-pointer top-3 right-3 z-10 size-8 flex items-center justify-center bg-white/50 text-gray-700 rounded-full hover:bg-white transition-colors">
          <span class="icon-[material-symbols--close] text-xl"></span>
        </button>

        <!-- 이미지 스와이퍼 영역 -->
        <div swiper [options]="mobilePopupSwiperOptions" class="swiper w-full relative">
          <div class="swiper-wrapper">
            @for (popup of visiblePopups(); track popup.id) {
              <div class="swiper-slide">
                @if (popup.link) {
                  <a
                    [href]="popup.link"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="block aspect-3/4 w-full overflow-hidden">
                    <img [src]="popup.image" [alt]="popup.title" class="block w-full h-full object-cover" />
                  </a>
                } @else {
                  <div class="aspect-3/4 w-full overflow-hidden">
                    <img [src]="popup.image" [alt]="popup.title" class="block w-full h-full object-cover" />
                  </div>
                }
              </div>
            }
          </div>
          <!-- 페이지네이션 (이미지 하단에 오버레이) -->
          @if (visiblePopups().length > 1) {
            <div class="swiper-pagination bottom-3!"></div>
          }
        </div>

        <!-- 하단 액션 영역 (항상 표시) -->
        <div class="w-full flex items-center justify-between px-4 py-3 border-t border-gray-200 bg-gray-50 shrink-0">
          <button
            (click)="hideAllForToday()"
            class="cursor-pointer text-sm text-gray-500 hover:text-primary transition-colors">
            오늘 하루 보지 않기
          </button>
          <button
            (click)="closeAllPopups()"
            class="cursor-pointer px-4 py-1.5 text-sm font-medium text-white bg-primary hover:brightness-90 rounded-md transition-colors">
            닫기
          </button>
        </div>
      </div>
    </div>
  </div>
}
